// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_2787e5dfdf--layout--TjvSZ","spinner":"_2787e5dfdf--spinner--uIpxO","container":"_2787e5dfdf--container--O_TQ1","error":"_2787e5dfdf--error--bfnyQ"};